import React, { useEffect } from "react";
import { useState } from "react";
import { getSiteRefrence } from "../../../api/endpoints/refrences";
import { authSelector } from "../../../store/selectors/index";
import { useSelector } from "react-redux";
import { message } from "antd";
import "./style.css";

export const ComponentToPrint = React.forwardRef(
  ({ item, enteredOn, endingDate }, ref) => {
    const { access_token } = useSelector(authSelector);
    const [siteName, setSiteName] = useState();
    const [siteAddress, setSiteAddress] = useState();
    const [formattedDate, setFormattedDate] = useState("");
    const [debitTotal, setDebitTotal] = useState();
    const [quantityTotal, setQuantityTotal] = useState();
    const [leftColumn, setLeftColumn] = useState([]);
    const [purchaseData, setPurchaseData] = useState([]);

    useEffect(() => {
      // Set the state of leftColumn and rightColumn
      setPurchaseData(item);
    }, [item]);

    const getName = async (e) => {
      const result = await getSiteRefrence(access_token);
      if (result.success) {
        console.log(result, "site");
        setSiteName(result.data.siteName);
        setSiteAddress(result.data.siteAddress);
      } else {
        message.error(result.message);
      }
    };

    useEffect(() => {
      getName();
    });

    function formatDate(inputDate) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      const formattedDate = new Date(inputDate).toLocaleDateString(
        undefined,
        options
      );
      return formattedDate;
    }

    // useEffect(() => {
    //   // Calculate the total sum using reduce

    //   const purchase = purchaseData.reduce((accumulator, ele) => {
    //     const purchaseTotal = parseFloat(ele.creditAmount);
    //     if (!isNaN(purchaseTotal) && isFinite(purchaseTotal)) {
    //       return accumulator + purchaseTotal;
    //     }
    //     // Handle non-numeric values as 0
    //     return accumulator;
    //   }, 0);

    //   const quantity = purchaseData.reduce((accumulator, ele) => {
    //     const quantityTotal = parseFloat(ele.quantity);
    //     if (!isNaN(quantityTotal) && isFinite(quantityTotal)) {
    //       return accumulator + quantityTotal;
    //     }
    //     // Handle non-numeric values as 0
    //     return accumulator;
    //   }, 0);

    //   setDebitTotal(parseFloat(purchase).toFixed(2));
    //   setQuantityTotal(parseFloat(quantity).toFixed(2));
    // }, [debitTotal]);

    return (
      <div ref={ref}>
        <div className="flex flex-col items-center justify-center">
          <strong>
            {" "}
            <h1 style={{ fontSize: "30px" }}>{siteName}</h1>
          </strong>
          <strong>
            {" "}
            <h1 style={{ fontSize: "17px" }}>{siteAddress}</h1>
          </strong>
          <strong className="flex">
            <h1 style={{ fontSize: "17px" }}>
              From {formatDate(enteredOn) || "Loading..."}
            </h1>
            <h1 className="ml-2" style={{ fontSize: "17px" }}>
              To {formatDate(endingDate) || "Loading..."}
            </h1>
          </strong>
          <strong className="">
            <h1 style={{ fontSize: "17px" }}>Tank Lorry Report</h1>
          </strong>
          <div className="flex justify-between w-52">
            <strong>
              {" "}
              {/* <h1 style={{ fontSize: "17px" }}>{purchaseData[0]?.partyId}</h1> */}
            </strong>
          </div>
        </div>
        <div class="relative mt-5 overflow-x-auto">
          <div className="">
            <div className="w-full border-2">
              <table class="w-full text-sm text-left text-black dark:text-gray-400">
                <thead class="text-black border-2 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                  <tr>
                    <th scope="col" class="w-auto">
                      {" "}
                      Date{" "}
                    </th>
                    <th scope="col" class="w-auto">
                      VNO.
                    </th>
                    {/* <th scope="col" class="w-auto">
                    {" "}
                    Item Name{" "}
                  </th>
                  <th scope="col" class="w-auto">
                    {" "}
                    Party Name{" "}
                  </th> */}
                    <th scope="col" class="w-auto">
                      Purchase Rate
                    </th>
                    {/* <th scope="col" class="w-auto">
                    Sale Rate
                  </th> */}
                    {/* <th scope="col" class="w-auto">
                    Margin
                  </th> */}
                    <th scope="col" class="w-auto">
                      Quantity
                    </th>
                    <th scope="col" class="w-auto">
                      Amount
                    </th>
                    <th scope="col" class="w-auto">
                      Return
                    </th>
                  </tr>
                </thead>
                {/* <tbody>
                <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <td class=""></td>
                  <td></td>
                  <td></td>
                  <td className="border-x-2">Opening Balance </td>
                  {openingCashTotal > 0 ? (
                    <td>
                      {formatValue(parseFloat(openingCashTotal).toFixed(2))}
                    </td>
                  ) : (
                    <td className="border-x-2"></td> // Render empty cell when openingCashTotal is less than or equal to 0
                  )}
                  {openingCashTotal < 0 ? (
                    <td className="border-x-2">
                      {formatValue(parseFloat(openingCashTotal).toFixed(2))}
                    </td>
                  ) : (
                    <td className="border-x-2"></td> // Render empty cell when openingCashTotal is greater than or equal to 0
                  )}
                </tr>
              </tbody> */}
                {purchaseData.length > 0 &&
                  purchaseData
                    // .slice()
                    // .sort((a, b) => new Date(a.enteredOn) - new Date(b.enteredOn))
                    .map((ele, i) => {
                      // Calculate the balance for the current entry
                      // let balance = 0;
                      // if (i === 0) {
                      //   // For the first entry, use openingCashTotal as the initial balance
                      //   balance =
                      //     (openingCashTotal || 0) -
                      //     (ele.credit || 0) +
                      //     (ele.debit || 0);
                      // } else {
                      //   // For subsequent entries, update the balance using the previous balance value
                      //   balance =
                      //     leftColumn[i - 1].balance +
                      //     (ele.debit || 0) -
                      //     (ele.credit || 0);
                      //   // leftColumn[i - 1].balance + ele.debit - ele.credit;
                      // }
                      // // Update the balance property in the current entry
                      // ele.balance = balance;
                      console.log(ele, "ele");

                      return (
                        <tbody key={i}>
                          {/* Make sure to add a unique key to each row */}
                          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                            {/* <td className="">{ele.enteredOn}</td> */}
                            <td>
                              {new Date(ele.enteredOn).toLocaleDateString(
                                "en-GB"
                              )}
                            </td>
                            <td className="border-x-2">{ele.VNO}</td>
                            {/* <td className="border-x-2">{ele.itemName}</td>
                          <td className="border-x-2">{ele.partyName}</td> */}
                            <td className=" border-x-2">
                              {isNaN(parseFloat(ele.purchaseRate))
                                ? "0"
                                : parseFloat(ele.purchaseRate)}
                            </td>
                            {/* <td className="border-x-2">
                            {isNaN(parseFloat(ele.saleRate))
                              ? "0"
                              : parseFloat(ele.saleRate)}
                          </td> */}
                            {/* <td className="border-x-2">
                            {parseFloat(
                              ele.saleRate - ele.purchaseRate
                            ).toFixed(2)}
                          </td> */}
                            <td className="border-x-2">{ele.quantity}</td>
                            <td className="border-x-2">
                              {parseFloat(ele.amount).toFixed(2)}
                            </td>
                            <td className="border-x-2">
                              {parseFloat(ele.retrn).toFixed(2)}
                            </td>
                          </tr>
                        </tbody>
                      );
                    })}
              </table>
              {/* <div className="w-full flex justify-center">
              <div className="">
                <div className="">
                  <h1> {`Total Amount: ${debitTotal}`} </h1>
                </div>
                <div className="">
                  <h1> {`Total Quantity: ${quantityTotal}`} </h1>
                </div>
              </div>
            </div> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
);
